import React from 'react'
import {connect, useDispatch} from "react-redux";

import { MdEdit, MdTrain, MdToys } from "react-icons/md";
import Toolbox from "./Toolbox";
import {setEditmode, setLccontainer} from "../../../data/actions";
import {useLocalStorage} from "../../etc/useLocalStorage";

const Editbar = ({root, scenario}) => {
    const dispatch = useDispatch()

    function onSubmit() {
        dispatch(setEditmode( !root.editmode))
    }

    function onLccontainer() {
        //dispatch(setLccontainer( !root.lccontainer))
    }

    function onBmBox() {

    }


    let color = root.editmode ? '#e70202' : '';

    return (
        <>
            <div className='bubble'
                 onClick={() => onSubmit()}>
                <MdEdit fontSize='small'/>
            </div>
            <Toolbox scenario={scenario}/>
        </>
    )
}

const mapStateToProps = state => {
    return state;
}

const mapDispatchToProps = dispatch => {
    return {
        onSubmit: (data) => {
            dispatch(
                {
                    type: "TOGGLE_EDIT",
                    edit: data
                }
            );
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Editbar)